import { saveCollegeList } from "application/store/reducers/CollegeListReducer";
import { APPLY_COLLEGE } from "application/utils/constants";
import { getCollegeListService } from "infrastructure/services/get-college-list.services";
import { MixpanelService } from "infrastructure/services/tracker/mixpanel.service";
import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";

export function useGetCollegeList() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getCollegeList = useCallback(
    async () => {
      if ( APPLY_COLLEGE ) {
        setIsLoading(true);
        MixpanelService.track(
          `Start: get college list`,
          true
        );

        try {
          const { data, isSuccess } = await getCollegeListService();

          if (isSuccess && Array.isArray(data) && data.length > 0) {
            MixpanelService.track(
              `${data}: get college list`,
              true
            );
            dispatch(saveCollegeList(data));
            return true
          } 
          return false;
        } catch (error) {
          console.error("Error fetching college list:", error);

          MixpanelService.track(
            `Errors list: get college list`,
            true
          );

          return false;
        } finally {
          setIsLoading(false);
        }
      } else {
        return true;
      }
    },
    [dispatch]
  );

  return {
    getCollegeList,
    isLoading,
  };
}
